import React from 'react'
import { IconPropsType } from '../types'

const AlertCircleIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      width='24'
      height='25'
      className={className}
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 8.32812V12.3281M12 16.3281H12.01M22 12.3281C22 17.851 17.5228 22.3281 12 22.3281C6.47715 22.3281 2 17.851 2 12.3281C2 6.80528 6.47715 2.32812 12 2.32812C17.5228 2.32812 22 6.80528 22 12.3281Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default AlertCircleIcon
